import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios, updateProgress } from '../../services'

const upload_image_request = () => {
  return {
    type: questionsTypes.upload_image.request
  }
}

const upload_image_success = (response) => {
  return {
    type: questionsTypes.upload_image.success,
    payload: response.data
  }
}

const upload_image_failure = (messages) => {
  return {
    type: questionsTypes.upload_image.failure,
    payload: messages
  }
}

const upload_image = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(upload_image_request())

    // Request
    axios.post(
      QUESTIONS_ROUTES.upload_image,
      values,
      {
        onUploadProgress: e => {
          dispatch( updateProgress(e) )
        }
      }
    ).then( response => {
      // success
      dispatch( upload_image_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error uploading image."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( upload_image_failure(errors))
    })
  }
}

export {
  upload_image
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/upload_image.js